module.exports = "/images/vendor/lightslider/dist/controls.png?75e5868a6b927d223a430b1caf4521a9";